import { productKind } from '@/config/productProfile'

const rawEnv = import.meta.env;

const trimTrailingSlash = (value: string) => value.replace(/\/+$/, '');

const readRequiredUrl = (key: string) => {
    const value = rawEnv[key] as string | undefined;

    if (!value) {
        throw new Error(`Missing required environment variable: ${key}`);
    }

    return trimTrailingSlash(value);
};

export const appEnv = rawEnv.VITE_APP_ENV || rawEnv.MODE || 'development';
export { productKind };

export const ymCounter = Number(rawEnv.VITE_YM_COUNTER || 0);
export const ymEnabled = ymCounter > 0;

export const apiBaseUrl = readRequiredUrl('VITE_API_BASE_URL');
export const productsApiBaseUrl = readRequiredUrl('VITE_PRODUCTS_API_BASE_URL');
export const logsApiUrl = readRequiredUrl('VITE_LOGS_API_URL');
export const ordersWsBaseUrl = readRequiredUrl('VITE_ORDERS_WS_BASE_URL');

export const sentryDsn = rawEnv.VITE_SENTRY_DSN || '';
export const sentryEnabled = rawEnv.VITE_SENTRY_ENABLED === 'true' && Boolean(sentryDsn);
export const sentryTracesSampleRate = Number(rawEnv.VITE_SENTRY_TRACES_SAMPLE_RATE || 0);

export const kioskServerUrl = trimTrailingSlash(
  rawEnv.VITE_KIOSK_SERVER_URL || 'https://server.kiosk.tubatay.tech/kiosk/api'
);
export const adminBaseUrl = trimTrailingSlash(
  rawEnv.VITE_ADMIN_BASE_URL || 'https://admin.tubatay.space'
);

const resolveWsBaseUrl = (value: string) => {
    if (!value.startsWith('/')) {
        return value;
    }

    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${protocol}//${window.location.host}${value}`;
};

export const buildOrderWsUrl = (orderId: string | number) => {
    return `${resolveWsBaseUrl(ordersWsBaseUrl)}/orders/${orderId}/`
};
